"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guid = exports.buildBiUrl = exports.getCookies = void 0;
var browser_1 = require("./browser");
var env_1 = require("./env");
var cacheKillerCounter = 0;
function getCookies(params) {
    return Object.keys(params).reduce(function (res, param) {
        var _a = typeof params[param] === 'string'
            ? { name: params[param] }
            : params[param], name = _a.name, _b = _a.transform, transform = _b === void 0 ? function (x) { return x; } : _b;
        var value = transform((0, browser_1.readCookie)(name));
        if (value) {
            res[param] = value;
        }
        return res;
    }, {});
}
exports.getCookies = getCookies;
function buildBiUrl(_a, params, context) {
    var _b = _a.host, host = _b === void 0 ? '' : _b, _c = _a.endpoint, endpoint = _c === void 0 ? '' : _c;
    if (context === void 0) { context = {}; }
    host = typeof host === 'function' ? host() : host;
    host = host || (0, env_1.getHost)();
    endpoint = context.endpoint || endpoint;
    if (!context.useBatch) {
        params._ = '' + new Date().getTime() + cacheKillerCounter++;
    }
    var pairs = context.useBatch
        ? []
        : Object.keys(params).map(function (key) {
            return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
        }, []);
    return ["//".concat(host, "/").concat(endpoint)]
        .concat(pairs.length ? pairs.join('&') : [])
        .join('?');
}
exports.buildBiUrl = buildBiUrl;
function guid() {
    /*eslint-disable */
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
    /*eslint-enable */
}
exports.guid = guid;
//# sourceMappingURL=utils.js.map